import { render, staticRenderFns } from "./OccupationSelectionList.vue?vue&type=template&id=155bfa04&scoped=true&"
import script from "./OccupationSelectionList.vue?vue&type=script&lang=ts&"
export * from "./OccupationSelectionList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155bfa04",
  null
  
)

export default component.exports